import { useToast as useToastProvider } from "vue-toastification";

export const useToast = () => {
  const toast = useToastProvider();

  const defaultOptions = {
    timeout: 1500,
    closeOnClick: false,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.5,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
  };

  const error = (message: string, timeout?: number) => {
    return toast.error(message, {
      ...defaultOptions,
      timeout: timeout || 5000,
      closeButton: "button",
    });
  };

  const success = (message: string, timeout?: number | false) =>
    toast.success(message, {
      ...defaultOptions,
      timeout: timeout || defaultOptions.timeout as number | false,
      closeButton: "button",
    });

  const info = (message: string, timeout?: number) =>
    toast.info(message, {
      ...defaultOptions,
      timeout: timeout || false,
      closeButton: "button",
    });

  const warn = (message: string, timeout?: number) =>
    toast.warning(message, {
      ...defaultOptions,
      timeout: timeout || 5000,
      closeButton: "button",
    });

  return {
    toast,
    defaultOptions,
    danger: error,
    success,
    info,
    warn,
    error,
  };
};

export const useToastUpdate = () => {
  const toast = useToastProvider();
  const activeToasts = new Set<string>(); // Хранит активные уведомления

  const defaultOptions = {
    timeout: 1500,
    closeOnClick: false,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.5,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
  };

  const updateToast = (
    id: string,
    message: string,
    timeoutArg?: number | boolean,
  ) => {
    const toastTimeout: number | boolean = timeoutArg || 3000;
    if (activeToasts.has(id)) {
      toast.update(id, {
        content: message,
        options: {
          ...defaultOptions,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          timeout: (toastTimeout || false) as any,
        },
      });
    }
    else {
      activeToasts.add(id);
      toast.info(message, {
        ...defaultOptions,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        timeout: (toastTimeout || false) as any,
        id,
        onClose: () => activeToasts.delete(id),
      });
    }
  };

  return {
    showInfo: updateToast,
  };
};
